import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datePerZoneTransform'
})
export class DatePerZonePipe implements PipeTransform {

  transform(value: any, dateFormat: string = 'medium'): any {
    if (!value) return null;


    const date = new Date(value);

    // Use browser language for formatting (same as Angular's date pipe)
    const locale = navigator.language || 'en-US';

    return formatDate(date, dateFormat, locale);
  }
}
